<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Swiper, { Autoplay } from 'swiper';


type Props = {
    images: any[],
}
const props = defineProps<Props>();
const swiper = ref<any>(null)
const swiperElt = ref<any>(null);



onMounted(() => {
    swiper.value = new Swiper(swiperElt.value, {
        modules: [Autoplay],
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 2,
        loopedSlides: 3,
        loop: true,
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 2500,
            pauseOnMouseEnter: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
                loopedSlides: 4,
            },
            768: {
                slidesPerView: 6,
                loopedSlides: 6,
            },
            992: {
                slidesPerView: 8,
                loopedSlides: 8,
            }
        }
    });

})

</script>
<style scoped lang="scss">
.swiper {

    .swiper-wrapper {
        align-items: center;
        cursor: pointer;

        .swiper-slide {
            display: flex;

            .cont {
                margin: auto;
                display: flex;

                img {
                    margin: auto;
                    max-width: 80%;
                    object-fit: contain;
                }
            }
        }
    }
}
</style>
<template>
    <div v-if="props.images.length > 0" ref="swiperElt" class="swiper projects-swiper" data-aos="fade">
        <div class="swiper-wrapper">
            <div v-for="(image, i) in props.images" :key="i" class="swiper-slide">
                <div class="cont">
                    <img :src="image.url" alt="img">
                </div>
            </div>
            <div v-for="(image, i) in props.images" :key="i" class="swiper-slide">
                <div class="cont">
                    <img :src="image.url" alt="img">
                </div>
            </div>
        </div>
    </div>
</template>